var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Input/index.tsx";
import React, { memo } from 'react';
import { TextInput } from '@adc/parallax-component-library';
import { InputErrorField } from 'Components/utility';
const Input = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  placeholder = '',
  onBlur,
  onChangeText,
  disabled,
  testID,
  inputMode,
  onFocus,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, Object.assign({
    inputMode: inputMode,
    label: label,
    placeholder: placeholder,
    onFocus: onFocus,
    onBlur: onBlur,
    error: isInvalid,
    onChangeText: onChangeText,
    testID: testID,
    disabled: disabled
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  })), isInvalid && errorMessage && /*#__PURE__*/React.createElement(InputErrorField, {
    errorMessage: errorMessage,
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }));
});
Input.displayName = 'Input';
export { Input };